export const payoutTapOnFeesSelectors = {
  gridData: (state) => state.gridData,
  update: (state) => state.update,
}
